
import {
  defineComponent, ref, onMounted, Ref,
} from 'vue';
import { useRouter } from 'vue-router';
import { Form } from 'vee-validate';
// eslint-disable-next-line import/no-cycle
import AppButton from '@/components/UI/AppButton.vue';
import AppRadio from '@/components/UI/AppRadio.vue';
import { useRegistrationStore } from '../store/registrationStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  components: {
    Form,
    AppButton,
    AppRadio,
  },
  setup() {
    const router = useRouter();
    const registrationStore = useRegistrationStore();
    const hippaValue: Ref<boolean | undefined> = ref(registrationStore.createUser.hippa);

    function nextStep() {
      if (hippaValue.value !== undefined) {
        registrationStore.createUser.hippa = hippaValue.value;
        router.push('step-2');
      }
    }

    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      nextStep,
      hippaValue,
    };
  },
});
